import React from 'react';
import { useQuery } from 'react-apollo';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './ContentPagePreview.css';
import Loader from '../../components/Common/Loader';
import PagePreview from '../../components/PagePreview/PagePreview';
import NotFound from '../not-found/NotFound';
import getContentPageQuery from './getContentPage.graphql';

function ContentPagePreview({ pageUrl }) {
    useStyles(s);

    const { data, loading } = useQuery(getContentPageQuery, {
        variables: { pageUrl },
        ssr: false
    });

    if (loading) return <Loader type="text" />;

    if (!data || !data.getContentPage) {
        return <NotFound title="Not Found" />;
    }

    return (
        <div>
            <PagePreview title={data.getContentPage.metaTitle} data={data} />
        </div>
    );
}

export default ContentPagePreview;
